<template>
  <v-container>
    <div
      :class="[`text-subtitle-1`]"
    >
      <h4>Skill(s)</h4>
    </div>
    <div
      class="card grey-card"
      v-for="(item, i) in skill_list"
      :key="i"
    >
      <v-row>
        <v-col md="11" sm="10" cols="10">
          <v-row>
            <v-col
              cols="6"
            >
              <v-select
                :items="skills"
                item-text="label"
                item-value="value"
                label="Skill"
                v-model="skill_list[i].skill"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col
              cols="6"
            >
              <v-select
                :items="levels"
                item-text="label"
                item-value="value"
                label="Level"
                v-model="skill_list[i].level"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="1" sm="2" cols="2">
          <v-btn
            @click="removeSkill(i)"
            small
            text
            color="red"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-btn
      @click="addSkill()"
      small
    >
      Add skill
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: 'AppSkill',
  props: ['skill_list', 'remove_skills'],
  data: () => ({
    skills: [
      { label: 'Cook Thai', value: 'Cook Thai' },
      { label: 'Cook Western', value: 'Cook Western' },
      { label: 'Cook Chinese', value: 'Cook Chinese' },
      { label: 'Cook Indian', value: 'Cook Indian' },
      { label: 'Cook Japanese', value: 'Cook Japanese' },
      { label: 'Cook Korean', value: 'Cook Korean' },
      { label: 'Cook Lao', value: 'Cook Lao' },
      { label: 'Cook Arabia', value: 'Cook Arabia' },
      { label: 'Cook baby/kid food', value: 'Cook baby/kid food' },
      { label: 'Cook Filipino', value: 'Cook Filipino' },
      { label: 'Take care of new-born baby', value: 'Take care of new-born baby' },
      { label: 'Take care of pet', value: 'Take care of pet' },
    ],
    levels: [
      { label: 'Little', value: 'little' },
      { label: 'Fair', value: 'fair' }
    ],
  }),
  methods: {
    addSkill () {
      this.skill_list.push({ skill: '', level: '' })
    },
    removeSkill (index) {
      if (this.skill_list[index].id)
        this.remove_skills.push(this.skill_list[index].id)
      this.skill_list.splice(index, 1)
    }
  },
}
</script>